/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { useMediaQuery } from 'react-responsive';
import { IContentBlockViewProps } from './custom-content-block';
import { msdyn365Commerce } from '@msdyn365-commerce/core';
type imageBreakpoint = 'sm' | 'md' | 'lg';
const ContentBlockView: React.FC<IContentBlockViewProps> = props => {
    const {
        contentBlockContainer,
        imageContainer,
        image_sm,
        image_md,
        image_lg,
        breakpoint_sm,
        breakpoint_lg,
        contentBlockAnchorTag,
        imageLink,
        imageAriaLabel
    } = props;

    const imageBreakpointMap: Record<imageBreakpoint, React.ReactNode | null> = {
        sm: image_sm,
        md: image_md,
        lg: image_lg
    };

    const getImageBreakpoint = () => {
        if (msdyn365Commerce.isBrowser) {
            const isLarge = useMediaQuery({ query: `(min-width: ${breakpoint_lg}px)` });
            const isMed = useMediaQuery({ query: `(max-width: ${breakpoint_lg || 0 - 1}px) and (min-width: ${breakpoint_sm}px)` });
            if (isLarge) {
                return 'lg';
            } else if (isMed) {
                return 'md';
            } else {
                return 'sm';
            }
        }
        return 'lg';
    };

    const getImage = (breakpoint: imageBreakpoint): React.ReactNode | null => {
        if (imageBreakpointMap[breakpoint]) {
            return imageBreakpointMap[breakpoint];
        } else {
            const keys = Object.keys(imageBreakpointMap);
            let idx = keys.findIndex(k => k === breakpoint);

            while (idx < keys.length) {
                const image = imageBreakpointMap[keys[idx]];
                if (image) {
                    return image;
                } else {
                    idx++;
                }
            }
            return null;
        }
    };
    if (!msdyn365Commerce.isBrowser) {
        return <div />;
    }
    if (imageLink) {
        return (
            <Module {...contentBlockContainer}>
                <Node
                    {...contentBlockAnchorTag}
                    href={imageLink}
                    className={contentBlockAnchorTag ? contentBlockAnchorTag.className : ''}
                    aria-label={imageAriaLabel}
                >
                    <Node {...imageContainer}>{getImage(getImageBreakpoint())}</Node>
                    {/*    /!* Responsive component renderring, using MediaQuery from react-responsive, render small, medium or large image based on breakpoint_sm and breakpoint_lg fields *!/*/}
                    {/*    <MediaQuery maxDeviceWidth={breakpoint_sm}>*/}
                    {/*        {' '}*/}
                    {/*        <Node {...imageContainer}>{getImage('sm')}</Node>*/}
                    {/*    </MediaQuery>*/}
                    {/*    <MediaQuery maxDeviceWidth={breakpoint_lg! - 1} minDeviceWidth={breakpoint_sm! + 1}>*/}
                    {/*        {' '}*/}
                    {/*        <Node {...imageContainer}>{getImage('md')}</Node>*/}
                    {/*    </MediaQuery>*/}
                    {/*    <MediaQuery minDeviceWidth={breakpoint_lg}>*/}
                    {/*        {' '}*/}
                    {/*        <Node {...imageContainer}>{getImage('lg')}</Node>*/}
                    {/*    </MediaQuery>*/}
                </Node>
            </Module>
        );
    } else {
        return (
            <Module {...contentBlockContainer}>
                <Node {...imageContainer}>{getImage(getImageBreakpoint())}</Node>
                {/* Responsive component renderring, using MediaQuery from react-responsive, render small, medium or large image based on breakpoint_sm and breakpoint_lg fields */}
                {/*<MediaQuery maxDeviceWidth={breakpoint_sm}>*/}
                {/*    {' '}*/}
                {/*    <Node {...imageContainer}>{getImage('sm')}</Node>*/}
                {/*</MediaQuery>*/}
                {/*<MediaQuery maxDeviceWidth={breakpoint_lg! - 1} minDeviceWidth={breakpoint_sm! + 1}>*/}
                {/*    {' '}*/}
                {/*    <Node {...imageContainer}>{getImage('md')}</Node>*/}
                {/*</MediaQuery>*/}
                {/*<MediaQuery minDeviceWidth={breakpoint_lg}>*/}
                {/*    {' '}*/}
                {/*    <Node {...imageContainer}>{getImage('lg')}</Node>*/}
                {/*</MediaQuery>*/}
            </Module>
        );
    }
};

export default ContentBlockView;
